import { fg } from '@atlassian/jira-feature-gating';

// Because jiv_confluence_remote_link_critical_query is paused, this is not used in issueViewInteractiveQuery
const getRemoteLinksQueryNew = () => `
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
		${
			fg('remove-remote-linked-issues')
				? ''
				: `remoteLinkedIssues {
                        preview {
                            id
                            issueId
                            globalId
                            href
                            applicationType
                            applicationName
                            relationship
                            title
                        }
                    }`
		}
    }
`;

const getRemoteLinksQueryOld = () => `
    remoteLinks {
        isLinkingEnabled
        ${
					fg('remove-remote-linked-issues')
						? ''
						: `remoteLinkedIssues {
                                preview {
                                    id
                                    issueId
                                    globalId
                                    href
                                    applicationType
                                    applicationName
                                    relationship
                                    title
                                }
                            }`
				}
    }
`;

// Paused since 4/9/2025: https://switcheroo.atlassian.com/ui/gates/e4d6ddcd-2623-4a2e-9851-1a9ad8076a94/key/jiv_confluence_remote_link_critical_query
export const getRemoteLinksQuery = (): string =>
	fg('jiv_confluence_remote_link_critical_query')
		? getRemoteLinksQueryNew()
		: getRemoteLinksQueryOld();
